import { AdminModulesConfig, AdminPanelRouteConfig } from "@constants/adminPanelRouting";
import { useMemo } from "react";
  
export const useAdminPanelRouteConfig = (): AdminPanelRouteConfig[] => {
    const adminPanelPages = useMemo(() => {
        return Object.keys(AdminModulesConfig).map((module) => {
        const moduleConfig = AdminModulesConfig[module];
        return {
            ...moduleConfig
        };
        });
    }, []);

    return adminPanelPages;
};
  